import Recorder from './Recorder'
import Converter from './Converter'
import Surfer from './Surfer'

export default class Core{
    constructor() {
        this.surfer = new Surfer(this)
        this.recorder = new Recorder(this)
        this.converter = Converter
        this.currentView = null;
        this.setView = null;
    }
}